/* QUELL — PDP "Spec sheet (PDF)": client-side A5 PDF from the [data-spec-sheet] payload; libs lazy-loaded on click. QUELL-115. */
(function () {
  "use strict";

  var SELF = (document.currentScript && document.currentScript.src) || "";
  var ASSET_BASE = SELF.replace(/spec-sheet\.js(\?.*)?$/, "");

  var loading = null;
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      s.async = false;
      s.onload = resolve;
      s.onerror = function () {
        reject(new Error("Failed to load " + src));
      };
      document.head.appendChild(s);
    });
  }
  function ensureLibs() {
    if (loading) return loading;
    loading = Promise.all([
      loadScript(ASSET_BASE + "jspdf.umd.min.js"),
      loadScript(ASSET_BASE + "spec-sheet-fonts.js"),
    ]).catch(function (err) {
      loading = null;
      throw err;
    });
    return loading;
  }

  function decodeEntities(s) {
    return String(s)
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, " ")
      .replace(/&#(\d+);/g, function (_, n) {
        return String.fromCharCode(+n);
      });
  }
  // decode entities + map the few glyphs the Manrope subset omits
  function safe(t) {
    if (t == null) return "";
    return decodeEntities(String(t))
      .replace(/\u2192/g, "->")
      .replace(/\u2190/g, "<-")
      .replace(/\u2264/g, "<=")
      .replace(/\u2265/g, ">=")
      .replace(/[\u00A0\u202F\u2007]/g, " ")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ");
  }
  function loadHero(url) {
    return new Promise(function (resolve) {
      if (!url) {
        resolve(null);
        return;
      }
      var img = new Image();
      var done = false;
      var finish = function (v) {
        if (!done) {
          done = true;
          resolve(v);
        }
      };
      img.crossOrigin = "anonymous";
      img.onload = function () {
        finish(img);
      };
      img.onerror = function () {
        finish(null);
      };
      setTimeout(function () {
        finish(null);
      }, 6000);
      img.src = url;
    });
  }
  // protocol-relative swatch URLs (//cdn…) → absolute https for CORS-safe canvas
  function normSwatchUrl(u) {
    u = String(u || "");
    return u.indexOf("//") === 0 ? "https:" + u : u;
  }
  // resolve a CSS colour keyword (the PDP's background-color fallback) → RGB.
  // Mirrors the storefront: "Orange"→orange, "Dark Green"→green, "Teal"→teal…
  // Returns null for non-colours ("Coffee", "Oak") so they fall back to a pill.
  function cssColorToHex(name) {
    name = String(name || "").trim();
    if (!name || typeof document === "undefined") return null;
    var tries = [name.toLowerCase(), name.split(/\s+/).pop().toLowerCase()];
    for (var i = 0; i < tries.length; i++) {
      var n = tries[i];
      if (!n || n === "transparent") continue;
      var el = document.createElement("span");
      el.style.color = "";
      el.style.color = n; // browsers ignore an invalid keyword → stays ""
      if (!el.style.color) continue;
      el.style.display = "none";
      document.body.appendChild(el);
      var c = getComputedStyle(el).color;
      document.body.removeChild(el);
      var m = c && c.match(/\d+/g);
      if (m) return [+m[0], +m[1], +m[2]];
    }
    return null;
  }
  // preload every swatch image up front so the swatch grid can draw the real
  // colour (image > hex > text, mirroring the PDP). Returns url → {url,w,h}.
  function loadSwatchImages(data) {
    var urls = {};
    (data.colourways || []).forEach(function (sec) {
      (sec.groups || []).forEach(function (g) {
        (g.swatches || []).forEach(function (s) {
          if (s && s.img) urls[normSwatchUrl(s.img)] = 1;
        });
      });
    });
    var list = Object.keys(urls);
    if (!list.length) return Promise.resolve({});
    return Promise.all(
      list.map(function (u) {
        return loadHero(u).then(function (img) {
          return { u: u, d: img ? heroDataUrl(img, "#ffffff", false) : null };
        });
      }),
    ).then(function (res) {
      var map = {};
      res.forEach(function (r) {
        if (r.d) map[r.u] = r.d;
      });
      return map;
    });
  }
  // multiply-blend a photo onto the flat card tint. `whiteBg` (sampled studio bg)
  // first normalises the photo's background to white, so a warm-cream studio bg
  // lands the same flat tint as a pure-white one instead of coming out warm.
  // `bg` is a colour string, or [topColour, bottomColour] for a diagonal gradient
  function setBg(ctx, bg, w, h) {
    if (Array.isArray(bg)) {
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, bg[0]);
      g.addColorStop(1, bg[1]);
      ctx.fillStyle = g;
    } else ctx.fillStyle = bg || "#ffffff";
  }
  function heroDataUrl(img, bg, multiply, whiteBg) {
    if (!img || !img.naturalWidth) return null;
    try {
      var c = document.createElement("canvas");
      c.width = img.naturalWidth;
      c.height = img.naturalHeight;
      var ctx = c.getContext("2d");
      if (multiply && whiteBg) {
        ctx.drawImage(img, 0, 0);
        var im = ctx.getImageData(0, 0, c.width, c.height),
          d = im.data,
          kr = 255 / Math.max(1, whiteBg[0]),
          kg = 255 / Math.max(1, whiteBg[1]),
          kb = 255 / Math.max(1, whiteBg[2]);
        for (var i = 0; i < d.length; i += 4) {
          d[i] = Math.min(255, d[i] * kr);
          d[i + 1] = Math.min(255, d[i + 1] * kg);
          d[i + 2] = Math.min(255, d[i + 2] * kb);
        }
        ctx.putImageData(im, 0, 0);
        ctx.globalCompositeOperation = "multiply";
        setBg(ctx, bg, c.width, c.height);
        ctx.fillRect(0, 0, c.width, c.height);
      } else {
        setBg(ctx, bg, c.width, c.height);
        ctx.fillRect(0, 0, c.width, c.height);
        if (multiply) ctx.globalCompositeOperation = "multiply";
        ctx.drawImage(img, 0, 0);
      }
      return { url: c.toDataURL("image/jpeg", 0.92), w: c.width, h: c.height };
    } catch (e) {
      return null;
    }
  }
  // diagonal card gradient (top→bottom-right) as a data URL for the card backgrounds
  function gradImg(top, bot) {
    try {
      var n = 240,
        c = document.createElement("canvas");
      c.width = n;
      c.height = n;
      var ctx = c.getContext("2d");
      setBg(ctx, [top, bot], n, n);
      ctx.fillRect(0, 0, n, n);
      return c.toDataURL("image/jpeg", 0.92);
    } catch (e) {
      return null;
    }
  }
  function rgbCss(a) {
    return "rgb(" + Math.round(a[0]) + "," + Math.round(a[1]) + "," + Math.round(a[2]) + ")";
  }
  function lighten(a, t) {
    return [a[0] + (255 - a[0]) * t, a[1] + (255 - a[1]) * t, a[2] + (255 - a[2]) * t];
  }
  // paint a rounded card with the gradient wash (flat cardBg fallback); leaves no clip
  function paintGradCard(doc, x, yy, w, h, radius, data) {
    doc.saveGraphicsState();
    doc.roundedRect(x, yy, w, h, radius, radius, null);
    doc.clip();
    doc.discardPath();
    if (data.gradUrl) doc.addImage(data.gradUrl, "JPEG", x, yy, w, h, undefined, "FAST");
    else {
      var b = data.cardBg || [239, 237, 229];
      doc.setFillColor(b[0], b[1], b[2]);
      doc.rect(x, yy, w, h, "F");
    }
    doc.restoreGraphicsState();
  }

  // sample a photo's studio background (top-left corner); null if unreadable or not a clean light bg
  function sampleBg(img) {
    if (!img || !img.naturalWidth) return null;
    try {
      var n = 10,
        c = document.createElement("canvas");
      c.width = n;
      c.height = n;
      var ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, Math.round(img.naturalWidth * 0.1), Math.round(img.naturalHeight * 0.1), 0, 0, n, n);
      var d = ctx.getImageData(0, 0, n, n).data,
        r = 0,
        g = 0,
        b = 0,
        k = d.length / 4;
      for (var i = 0; i < d.length; i += 4) {
        r += d[i];
        g += d[i + 1];
        b += d[i + 2];
      }
      r /= k;
      g /= k;
      b /= k;
      return Math.min(r, g, b) < 210 ? null : [r, g, b];
    } catch (e) {
      return null;
    }
  }
  // crop a dimension drawing's transparent margins; output the real image (native
  // alpha) as a PNG so it sits on the card as-is — no background processing
  function trimmedDataUrl(img, bg) {
    bg = bg || "#ffffff";
    if (!img || !img.naturalWidth) return null;
    try {
      var w = img.naturalWidth,
        h = img.naturalHeight;
      var s = Math.min(1, 480 / Math.max(w, h));
      var sc = document.createElement("canvas");
      sc.width = Math.max(1, Math.round(w * s));
      sc.height = Math.max(1, Math.round(h * s));
      var sctx = sc.getContext("2d");
      // scan on WHITE so the transparent margins are detected for the crop
      sctx.fillStyle = "#ffffff";
      sctx.fillRect(0, 0, sc.width, sc.height);
      sctx.drawImage(img, 0, 0, sc.width, sc.height);
      var d = sctx.getImageData(0, 0, sc.width, sc.height).data;
      var minX = sc.width,
        minY = sc.height,
        maxX = -1,
        maxY = -1;
      for (var yy = 0; yy < sc.height; yy++)
        for (var xx = 0; xx < sc.width; xx++) {
          var i = (yy * sc.width + xx) * 4;
          if (d[i] < 246 || d[i + 1] < 246 || d[i + 2] < 246) {
            if (xx < minX) minX = xx;
            if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy;
            if (yy > maxY) maxY = yy;
          }
        }
      if (maxX < 0) return heroDataUrl(img, bg, false);
      var pad = Math.round(Math.max(sc.width, sc.height) * 0.02) + 1;
      minX = Math.max(0, minX - pad);
      minY = Math.max(0, minY - pad);
      maxX = Math.min(sc.width - 1, maxX + pad);
      maxY = Math.min(sc.height - 1, maxY + pad);
      var sx = minX / s,
        sy = minY / s,
        sw = (maxX - minX + 1) / s,
        sh = (maxY - minY + 1) / s;
      var c = document.createElement("canvas");
      c.width = Math.max(1, Math.round(sw));
      c.height = Math.max(1, Math.round(sh));
      var ctx = c.getContext("2d");
      // use the real drawing as-is (native transparency, cropped to fill); no knockout
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, c.width, c.height);
      return { url: c.toDataURL("image/png"), w: c.width, h: c.height, png: true };
    } catch (e) {
      return heroDataUrl(img, bg, false);
    }
  }

  var HEX_RE = /^#[0-9a-f]{3,8}$/i;
  var FABRIC_PREFIXES = ["Gabriel Medley"];
  var MATERIAL_SUFFIXES = ["Ribbed Pet Board", "Pet Board", "Ribbed", "Corrugated"];
  function configRow(axName, name, labels) {
    var low = String(name).toLowerCase();
    var label = axName,
      i,
      part;
    for (i = 0; i < FABRIC_PREFIXES.length; i++) {
      part = FABRIC_PREFIXES[i].toLowerCase();
      if (low.indexOf(part + " ") === 0) {
        label = axName.replace(/colou?r/i, labels.fabricColour);
        break;
      }
    }
    if (label === axName) {
      for (i = 0; i < MATERIAL_SUFFIXES.length; i++) {
        part = MATERIAL_SUFFIXES[i].toLowerCase();
        if (
          low.length > part.length + 1 &&
          low.slice(-(part.length + 1)) === " " + part
        ) {
          label = axName.replace(/colou?r/i, labels.colourMaterial);
          break;
        }
      }
    }
    return { label: label, value: name };
  }
  function patchLive(data, opts) {
    // `opts` is either { scope, variantId } (new) or a DOM element for backward
    // compat with any caller that still passes the scope directly. Two ways to
    // pick a variant, in priority order:
    //   1. `variantId` passed explicitly (dealer library path — no DOM to read)
    //   2. `scope.dataset.specVariant` (PDP path — set by section-product-main.js
    //      on every colour/size click)
    // Null-safe on scope for the dealer library, where there is no PDP scope.
    var scope, variantId;
    if (opts && typeof opts === "object" && (opts.scope || opts.variantId)) {
      scope = opts.scope || null;
      variantId = opts.variantId || null;
    } else {
      scope = opts || null;
      variantId = null;
    }
    var vid = String(
      variantId || (scope && scope.dataset && scope.dataset.specVariant) || "",
    );
    var v = data.variants && data.variants[vid];
    if (!v) return data;
    if (!data.price.isPoa && v.display) data.price.display = v.display;
    if (v.img) data.hero = v.img;
    // per-variant spec-sheet media (variant metafields; product-level is the default)
    if (v.dim) data.dimImage = v.dim;
    if (v.int) data.interiorImage = v.int;
    data.stock.inStock = !!v.available;
    data.stock.label = v.available ? data.stock.inLabel : data.stock.outLabel;
    var colourAxes = {};
    (data.colourways || []).forEach(function (sec) {
      if (sec.label) colourAxes[sec.label] = 1;
    });
    var matItems = [],
      optItems = [];
    data.selectedNames = {};
    (data.optionAxes || []).forEach(function (ax) {
      var raw = (v.opts || [])[ax.pos - 1];
      var name = (ax.values && ax.values[raw]) || raw;
      if (!name || HEX_RE.test(String(name).trim())) return;
      data.selectedNames[name] = 1;
      var row = configRow(ax.name, name, data.labels);
      if (colourAxes[ax.name]) {
        matItems.push(row);
      } else {
        var trimmed = row.label.replace(/\s*options?\s*$/i, "");
        if (trimmed) row.label = trimmed;
        optItems.push(row);
      }
    });
    if (data.specGroups) {
      if (matItems.length) {
        var target = null;
        for (var gi = 0; gi < data.specGroups.length; gi++) {
          if (/material|finish/i.test(data.specGroups[gi].group || "")) {
            target = data.specGroups[gi];
            break;
          }
        }
        if (target) target.items = matItems.concat(target.items);
        else
          data.specGroups.unshift({
            group: data.labels.config,
            items: matItems,
          });
      }
      if (optItems.length)
        data.specGroups.unshift({
          group: data.labels.options,
          items: optItems,
        });
    }
    return data;
  }

  var UNIT_CHAIN_RE = /((?:\d+(?:[.,]\d+)?\s*[×x]\s*)*\d+(?:[.,]\d+)?)\s*(mm|cm)\b/gi;
  var BARE_CHAIN_RE = /(?:\d+(?:[.,]\d+)?\s*[×x]\s*)+\d+(?:[.,]\d+)?/g;
  function toIn(n, unit) {
    var f = String(unit).toLowerCase() === "cm" ? 2.54 : 25.4;
    return String(
      Math.round((parseFloat(String(n).replace(",", ".")) / f) * 10) / 10,
    );
  }
  function mmToIn(s, implied) {
    var out = String(s).replace(UNIT_CHAIN_RE, function (_, nums, unit) {
      return (
        nums
          .split(/\s*[×x]\s*/)
          .map(function (n) {
            return toIn(n, unit);
          })
          .join(" × ") + " in"
      );
    });
    if (implied && !/\b(mm|cm|in)\b/i.test(out)) {
      out = out.replace(BARE_CHAIN_RE, function (chain) {
        return (
          chain
            .split(/\s*[×x]\s*/)
            .map(function (n) {
              return toIn(n, "mm");
            })
            .join(" × ") + " in"
        );
      });
    }
    return out;
  }
  function localiseUnits(data) {
    if (data.units !== "imperial") return data;
    (data.specGroups || []).forEach(function (g) {
      var implied = /dimension/i.test(g.group || "");
      (g.items || []).forEach(function (it) {
        it.label = mmToIn(it.label);
        it.value = mmToIn(it.value, implied);
      });
    });
    (data.keyStats || []).forEach(function (c) {
      if (c.n != null) c.n = mmToIn(c.n);
      if (c.label != null) c.label = mmToIn(c.label);
    });
    return data;
  }

  // palette (tokens/colors.css)
  var REED = [94, 107, 82],
    REED_DEEP = [71, 81, 59],
    REED_INK = [51, 59, 41],
    REED_SOFT = [219, 224, 209],
    REED_MIST = [237, 239, 231],
    REED_LINE = [201, 208, 188],
    INK = [26, 27, 22],
    INK_SOFT = [50, 52, 43],
    MUTED = [106, 108, 96],
    SUBTLE = [154, 156, 143],
    LINE = [226, 224, 214],
    WHITE = [255, 255, 255],
    BONE = [239, 237, 229];

  function buildPdf(data, hero, opts) {
    // compact tightens gaps so a sparse product collapses to one page
    var compact = !!(opts && opts.compact),
      GAP = compact ? 0.72 : 1;
    var ebGap = compact ? 2.5 : 3.5;
    var headPad = 0;
    var headGap = compact ? 4.0 : 8.0;
    var atTop = true;
    var jsPDF = window.jspdf.jsPDF;

    var doc = new jsPDF({
      unit: "mm",
      format: "a5",
      compress: true,
      putOnlyUsedFonts: true,
    });
    // A5; 40px uniform margin
    var W = 148,
      H = 210,
      M = (40 * 25.4) / 96,
      CW = W - 2 * M,
      BOTTOM = (40 * 25.4) / 96;
    var y = M + headPad;

    function mm(pt) {
      return (pt * 25.4) / 72;
    }
    function vgap(n) {
      return n * GAP;
    }
    function fill(c) {
      doc.setFillColor(c[0], c[1], c[2]);
    }
    function stroke(c) {
      doc.setDrawColor(c[0], c[1], c[2]);
    }
    function ink(c) {
      doc.setTextColor(c[0], c[1], c[2]);
    }
    function font(style, size) {
      doc.setFont("Manrope", style);
      doc.setFontSize(size);
    }
    function hexRGB(h) {
      h = String(h || "")
        .trim()
        .replace(/^#/, "");
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16);
      return h.length === 6 && !isNaN(n)
        ? [(n >> 16) & 255, (n >> 8) & 255, n & 255]
        : null;
    }
    function rule(yy, c) {
      stroke(c || LINE);
      doc.setLineWidth(0.3);
      doc.line(M, yy, W - M, yy);
    }
    // right-align tracked text so its edge sits at xr (jsPDF align:right ignores charSpace)
    function textRightCS(txt, xr, yy, cs) {
      var wdt = doc.getTextWidth(txt) + cs * Math.max(0, txt.length - 1);
      doc.text(txt, xr - wdt, yy, { baseline: "top", charSpace: cs });
    }

    // continued-page header (atTop then suppresses the first section divider)
    function contHeader() {
      font("extrabold", 8.5);
      ink(INK);
      var wd = safe(data.logo.word || "Quell");
      doc.text(wd, M, y, { baseline: "top" });
      var wx = M + doc.getTextWidth(wd);
      ink(REED);
      doc.text(safe(data.logo.accent || "."), wx, y, { baseline: "top" });
      wx += doc.getTextWidth(safe(data.logo.accent || "."));
      ink(INK);
      doc.text(" " + safe(data.title), wx, y, { baseline: "top" });
      font("bold", 6);
      ink(SUBTLE);
      textRightCS(
        safe(data.labels.continued).toUpperCase(),
        W - M,
        y + 0.8,
        0.3,
      );
      y += mm(8.5) + 2.5;
      rule(y);
      y += 4.5;
      atTop = true;
    }
    function ensure(space) {
      if (y + space > H - BOTTOM) {
        doc.addPage();
        y = M + headPad;
        contHeader();
      }
    }

    // section eyebrow; keepWith stays with it; draws a divider above unless at a page top
    function eyebrow(txt, keepWith) {
      var adv = mm(6.6) + ebGap;
      var divH = atTop ? 0 : vgap(4);
      ensure(divH + adv + (keepWith != null ? keepWith : 3.7));
      if (!atTop) {
        rule(y);
        y += vgap(4);
      }
      atTop = false;
      var eyeC = y + 1.2;
      stroke(REED);
      doc.setLineWidth(0.4);
      doc.line(M, eyeC, M + 3.6, eyeC);
      font("bold", 6.6);
      ink(REED);
      doc.text(safe(txt).toUpperCase(), M + 5, eyeC, {
        baseline: "middle",
        charSpace: 0.3,
      });
      y += adv;
    }

    (function () {
      var top = y;
      font("extrabold", 16);
      ink(INK);
      doc.text(safe(data.logo.word || "Quell"), M, top, { baseline: "top" });
      var wx = M + doc.getTextWidth(safe(data.logo.word || "Quell"));
      ink(REED);
      doc.text(safe(data.logo.accent || "."), wx, top, { baseline: "top" });
      font("bold", 5.4);
      ink(SUBTLE);
      doc.text(safe(data.logo.sub || "").toUpperCase(), M, top + mm(16) + 1.7, {
        baseline: "top",
        charSpace: 0.5,
      });
      font("bold", 6);
      ink(REED);
      textRightCS(safe(data.doc.label).toUpperCase(), W - M, top + 0.4, 0.3);
      font("normal", 6.4);
      ink(MUTED);
      doc.text(safe(data.doc.type), W - M, top + mm(6) + 2.0, {
        align: "right",
        baseline: "top",
      });
      doc.text(safe(data.doc.rev), W - M, top + mm(6) + 2.0 + mm(6.4) + 1.2, {
        align: "right",
        baseline: "top",
      });
      y = top + mm(16) + headGap;
    })();
    rule(y);
    y += vgap(5);
    atTop = false;

    (function () {
      var top = y,
        shotW = 52,
        gap = 6,
        infoX = M + shotW + gap,
        infoW = CW - shotW - gap;
      var shotH = Math.min((shotW * 3.4) / 3, 52);
      paintGradCard(doc, M, top, shotW, shotH, mm(7.5), data);
      stroke(REED_LINE);
      doc.setLineWidth(0.3);
      doc.roundedRect(M, top, shotW, shotH, mm(7.5), mm(7.5), "S");
      if (hero && hero.url) {
        var r = hero.w / hero.h;
        var iw = shotW,
          ih = shotW / r;
        if (ih > shotH) {
          ih = shotH;
          iw = shotH * r;
        }
        doc.saveGraphicsState();
        doc.roundedRect(M, top, shotW, shotH, mm(7.5), mm(7.5), null);
        doc.clip();
        doc.discardPath();
        doc.addImage(
          hero.url,
          "JPEG",
          M + (shotW - iw) / 2,
          top + (shotH - ih) / 2,
          iw,
          ih,
          undefined,
          "FAST",
        );
        doc.restoreGraphicsState();
        stroke(REED_LINE);
        doc.setLineWidth(0.3);
        doc.roundedRect(M, top, shotW, shotH, mm(7.5), mm(7.5), "S");
      }
      if (data.stock && data.stock.label) {
        font("bold", 5.6);
        var bl = safe(data.stock.label),
          bw = doc.getTextWidth(bl) + 4;
        fill(data.stock.inStock ? REED_SOFT : [232, 228, 218]);
        doc.roundedRect(M + 2.6, top + 2.6, bw, 4.4, mm(3), mm(3), "F");
        ink(data.stock.inStock ? REED_INK : MUTED);
        doc.text(bl, M + 2.6 + 2, top + 2.6 + 2.2, { baseline: "middle" });
      }
      var iy = top;
      ink(REED);
      stroke(REED);
      doc.setLineWidth(0.4);
      var eyeIC = iy + 1.2;
      doc.line(infoX, eyeIC, infoX + 3.6, eyeIC);
      // shrink the eyebrow to fit the info column (long translations overflow)
      var eyeTxt = safe(data.eyebrow).toUpperCase(),
        eyeAvail = infoW - 5,
        eyeCS = 0.25,
        eyeSize = 6.4;
      font("bold", eyeSize);
      while (
        eyeSize > 4.4 &&
        doc.getTextWidth(eyeTxt) + eyeCS * Math.max(0, eyeTxt.length - 1) > eyeAvail
      ) {
        eyeSize -= 0.2;
        font("bold", eyeSize);
      }
      doc.text(eyeTxt, infoX + 5, eyeIC, { baseline: "middle", charSpace: eyeCS });
      iy += mm(6.4) + 1.5;
      font("extrabold", 20);
      ink(INK);
      doc.setLineHeightFactor(1.0);
      var tl = doc.splitTextToSize(safe(data.title), infoW);
      doc.text(tl, infoX, iy, { baseline: "top" });
      iy += tl.length * mm(20) * 1.0 + 4;
      doc.setLineHeightFactor(1.15);
      if (data.subtitle) {
        font("normal", 8.5);
        ink(MUTED);
        var sl = doc.splitTextToSize(safe(data.subtitle), infoW);
        doc.text(sl, infoX, iy, { baseline: "top" });
        iy += sl.length * mm(8.5) * 1.3 + 3.5;
      }
      var hasSmp = !data.price.isPoa && data.price.smp;
      var smpH = hasSmp ? mm(6.4) + 1 : 0;
      if (data.blurb) {
        font("normal", 7.4);
        ink(INK_SOFT);
        doc.setLineHeightFactor(1.5);
        var bl2 = doc.splitTextToSize(safe(data.blurb), infoW);
        var room = Math.min(
          4,
          Math.max(1, Math.floor((top + shotH - mm(15) - smpH - iy) / mm(7.4 * 1.5))),
        );
        if (bl2.length > room) {
          bl2 = bl2.slice(0, room);
          bl2[bl2.length - 1] =
            bl2[bl2.length - 1].replace(/\s*\S+$/, "") + " …";
        }
        doc.text(bl2, infoX, iy, { baseline: "top" });
        iy += bl2.length * mm(7.4) * 1.5;
        doc.setLineHeightFactor(1.15);
      }
      var py = Math.max(iy + 1, top + shotH - mm(13) - smpH);
      font("extrabold", 13);
      ink(REED_DEEP);
      doc.text(safe(data.price.display), infoX, py, { baseline: "top" });
      var pw = doc.getTextWidth(safe(data.price.display));
      if (data.price.note) {
        font("normal", 6.4);
        ink(SUBTLE);
        doc.text(
          safe(data.price.note),
          infoX + pw + 2,
          py + mm(13) - mm(6.4) - 0.3,
          { baseline: "top" },
        );
      }
      var bandBottom = py + mm(13);
      if (hasSmp) {
        font("normal", 6.4);
        ink(SUBTLE);
        var smpY = py + mm(13) + 1;
        doc.text(safe(data.price.smp), infoX, smpY, { baseline: "top" });
        bandBottom = smpY + mm(6.4);
      }
      y = Math.max(top + shotH, bandBottom) + vgap(4);
    })();
    y += vgap(5);

    // key-stats / ordering band; number + label centred vertically
    function statBand(cells, rounded) {
      if (!cells || !cells.length) return;
      ensure(17);
      var n = cells.length,
        bandH = 15,
        cw = CW / n;
      if (rounded) {
        fill(REED_MIST);
        stroke(REED_LINE);
        doc.setLineWidth(0.3);
        doc.roundedRect(M, y, CW, bandH, mm(10), mm(10), "FD");
      } else {
        fill(REED_MIST);
        doc.rect(M, y, CW, bandH, "F");
        stroke(REED_LINE);
        doc.setLineWidth(0.3);
        doc.line(M, y, W - M, y);
        doc.line(M, y + bandH, W - M, y + bandH);
      }
      for (var i = 0; i < n; i++) {
        var cx = M + i * cw,
          c = cells[i];
        if (i > 0) {
          stroke(REED_LINE);
          doc.setLineWidth(0.3);
          doc.line(cx, y + 1.5, cx, y + bandH - 1.5);
        }
        font("normal", 6);
        var lab = doc.splitTextToSize(
          safe(c.label != null ? c.label : c.k),
          cw - 6,
        );
        var nLab = Math.min(lab.length, 3);
        var numCap = mm(11.5) * 0.72,
          labCap = mm(6) * 0.72,
          nlGap = 2.8,
          labLH = mm(6) * 1.15;
        var top0 =
          y + (bandH - (numCap + nlGap + (nLab - 1) * labLH + labCap)) / 2;
        var big = safe(c.n != null ? c.n : c.v),
          bigSize = 11.5;
        font("extrabold", bigSize);
        while (bigSize > 7 && doc.getTextWidth(big) > cw - 7) {
          bigSize -= 0.5;
          font("extrabold", bigSize);
        }
        ink(REED_INK);
        doc.text(big, cx + 3.5, top0, {
          baseline: "top",
        });
        font("normal", 6);
        ink(REED_DEEP);
        for (var j = 0; j < nLab; j++)
          doc.text(lab[j], cx + 3.5, top0 + numCap + nlGap + j * labLH, {
            baseline: "top",
          });
      }
      y += bandH + vgap(5);
    }
    statBand(data.keyStats, false);

    // Full spec order: Dimensions + drawing first, Materials next, rest in the grid
    // (locals only — buildPdf reruns on the same data in the compact path)
    var specAll = data.specGroups || [];
    var dimsGroup = null,
      restGroups = [];
    for (var si = 0; si < specAll.length; si++) {
      // isDims is a language-agnostic flag from Liquid; regex is an EN fallback
      if (!dimsGroup && (specAll[si].isDims || /dimension/i.test(specAll[si].group || "")))
        dimsGroup = specAll[si];
      else restGroups.push(specAll[si]);
    }
    var firstG = [],
      laterG = [];
    restGroups.forEach(function (g) {
      (/material|finish/i.test(g.group || "") ? firstG : laterG).push(g);
    });
    // items in reading order; the two images are column-pinned (drawing top-right,
    // interior below Dimensions left) so layout holds even when one is absent
    var items = [];
    if (dimsGroup) items.push({ g: dimsGroup });
    if (data.dimImg) items.push({ img: data.dimImg, rounded: false, col: 1 });
    if (data.interiorImg) items.push({ img: data.interiorImg, rounded: true, col: 0 });
    firstG.concat(laterG).forEach(function (g) {
      items.push({ g: g });
    });
    if (items.length) {
      var gap = 5,
        colW = (CW - gap) / 2,
        colX = [M, M + colW + gap];
      // spacing scale: row padding < row leading < header gap < group gap
      var SZ = 6.5,
        rowPadV = compact ? 1.6 : 2.5,
        grpGap = compact ? 2.4 : 3.2,
        grpTail = compact ? 1.0 : 1.5,
        lineLH = mm(6.5) * 1.45,
        labW = colW * 0.42,
        valW = colW * 0.56;
      // one uniform row size; a long label/value wraps instead of shrinking
      function rowH(it) {
        font("normal", SZ);
        var l = doc.splitTextToSize(safe(it.label), labW).length;
        font("semibold", SZ);
        var v = doc.splitTextToSize(safe(it.value), valW).length;
        var lines = Math.max(1, l, v);
        return rowPadV + (lines - 1) * lineLH + mm(SZ) + rowPadV;
      }
      // height of group g rows [from,to); noHeader omits the header/rule
      function groupH(g, from, to, noHeader) {
        from = from || 0;
        to = to == null ? g.items.length : to;
        var h = noHeader ? 0 : mm(6.6) + grpGap;
        for (var i = from; i < to; i++) h += rowH(g.items[i]);
        return h;
      }
      // rows from `from` that fit in a budget height (incl. header unless noHeader)
      function rowsThatFit(g, from, budget, noHeader) {
        var used = noHeader ? 0 : mm(6.6) + grpGap,
          n = 0;
        for (var i = from; i < g.items.length; i++) {
          var rh = rowH(g.items[i]);
          if (used + rh > budget) break;
          used += rh;
          n++;
        }
        return n;
      }
      // draws rows [from,to); noHeader omits the header + top rule for continuations
      function drawGroup(g, x, yy, from, to, noHeader) {
        from = from || 0;
        to = to == null ? g.items.length : to;
        var ry = yy;
        if (!noHeader) {
          stroke(REED);
          doc.setLineWidth(0.3);
          doc.line(x, yy, x + colW, yy);
          font("bold", 6.6);
          ink(REED);
          doc.text(safe(g.group).toUpperCase(), x, yy + 1.8, {
            baseline: "top",
            charSpace: 0.2,
          });
          ry = yy + mm(6.6) + grpGap;
        } else {
          // continuation: a hairline row divider at the top for separation
          stroke(LINE);
          doc.setLineWidth(0.2);
          doc.line(x, yy, x + colW, yy);
        }
        for (var ri = from; ri < to; ri++) {
          var it = g.items[ri];
          font("normal", SZ);
          var dt = doc.splitTextToSize(safe(it.label), labW);
          font("semibold", SZ);
          var dd = doc.splitTextToSize(safe(it.value), valW);
          var lines = Math.max(1, dt.length, dd.length);
          var baseY = ry + rowPadV + mm(SZ) / 2;
          ink(MUTED);
          font("normal", SZ);
          for (var a = 0; a < dt.length; a++)
            doc.text(dt[a], x, baseY + a * lineLH, { baseline: "middle" });
          ink(INK);
          font("semibold", SZ);
          for (var b = 0; b < dd.length; b++)
            doc.text(dd[b], x + colW, baseY + b * lineLH, {
              align: "right",
              baseline: "middle",
            });
          ry = ry + rowPadV + (lines - 1) * lineLH + mm(SZ) + rowPadV;
          if (ri < to - 1) {
            stroke(LINE);
            doc.setLineWidth(0.2);
            doc.line(x, ry, x + colW, ry);
          }
        }
        return ry;
      }
      // Fixed-height gradient card: drawing contain-fits centred (transparent, so the
      // gradient shows through); interior photo covers the whole box
      function drawImg(img, x, yy, w, boxH, rounded) {
        var r = img.w / img.h;
        paintGradCard(doc, x, yy, w, boxH, mm(7.5), data);
        doc.saveGraphicsState();
        doc.roundedRect(x, yy, w, boxH, mm(7.5), mm(7.5), null);
        doc.clip();
        doc.discardPath();
        if (rounded) {
          var dw = w,
            dh = w / r;
          if (dh < boxH) {
            dh = boxH;
            dw = boxH * r;
          }
          doc.addImage(img.url, "JPEG", x + (w - dw) / 2, yy + (boxH - dh) / 2, dw, dh, undefined, "FAST");
        } else {
          var pad = mm(3.2),
            aw = w - pad * 2,
            ah = boxH - pad * 2,
            iw = aw,
            ih = aw / r;
          if (ih > ah) {
            ih = ah;
            iw = ah * r;
          }
          doc.addImage(img.url, img.png ? "PNG" : "JPEG", x + (w - iw) / 2, yy + (boxH - ih) / 2, iw, ih, undefined, "FAST");
        }
        doc.restoreGraphicsState();
        return boxH;
      }
      // one fixed size for every image (IMG_MIN == IMG_BOX disables the tail-gap shrink)
      var IMG_BOX = compact ? 46 : 52,
        IMG_MAX = IMG_BOX,
        IMG_MIN = IMG_BOX;
      function itemH(it) {
        if (it.g) return groupH(it.g, it.from || 0, null, it.noHeader);
        return IMG_BOX;
      }
      // neighbour-aware gap: group→group full air, →image tight, image→group small
      function gapBefore(prev, it) {
        if (!prev) return 0;
        if (!it.g) return 2.6;
        if (!prev.g) return prev.rounded ? 4 : 2.5;
        return grpTail;
      }
      function place(it, c, imgMax) {
        colY[c] += gapBefore(colLast[c], it);
        if (it.g) {
          colY[c] = drawGroup(it.g, colX[c], colY[c], it.from || 0, null, it.noHeader);
        } else {
          colY[c] += drawImg(it.img, colX[c], colY[c], colW, imgMax, it.rounded);
        }
        colLast[c] = it;
      }
      // Sequenced flow (Dimensions·L, drawing·R, interior·L, Materials·R…): the
      // front item keeps its place, splitting at a row boundary when too tall while
      // trailing groups backfill the gap; a split continues on the next page's left.
      var SPLIT_MIN = 40; // don't split groups shorter than this — move whole
      function newPage() {
        doc.addPage();
        y = M + headPad;
        contHeader();
        colY = [y, y];
        colLast = [null, null];
        freshTop = y;
      }
      function isFresh() {
        return colY[0] === freshTop && colY[1] === freshTop;
      }
      function fits(it, c) {
        if (it.nextPageOnly && !isFresh()) return false;
        return colY[c] + gapBefore(colLast[c], it) + itemH(it) <= H - BOTTOM;
      }
      var queue = items.slice();
      var gridTop = y,
        colY = [gridTop, gridTop],
        colLast = [null, null],
        freshTop = gridTop;
      while (queue.length) {
        var f = queue[0];
        if (isFresh()) f.nextPageOnly = false; // lock satisfied on a fresh page
        // pinned anchor images keep their column; everything else takes the shorter
        var c = f.col != null ? f.col : colY[0] <= colY[1] ? 0 : 1;
        // 1) place the front item where it belongs, if it fits whole
        if (fits(f, c)) {
          place(f, c, IMG_MAX);
          queue.shift();
          continue;
        }
        if (f.col == null && fits(f, 1 - c)) {
          place(f, 1 - c, IMG_MAX);
          queue.shift();
          continue;
        }
        // 2) front too tall — split a group at a row boundary
        if (!f.nextPageOnly) {
          if (!f.g) {
            var room = H - BOTTOM - colY[c] - gapBefore(colLast[c], f);
            if (room >= IMG_MIN) {
              place(f, c, room);
              queue.shift();
              continue;
            }
          } else {
            var from = f.from || 0;
            var nfit = rowsThatFit(f.g, from, H - BOTTOM - colY[c] - gapBefore(colLast[c], f), f.noHeader);
            if (
              groupH(f.g, from, null, f.noHeader) >= SPLIT_MIN &&
              nfit >= 2 &&
              f.g.items.length - from - nfit >= 1
            ) {
              colY[c] += gapBefore(colLast[c], f);
              colY[c] = drawGroup(f.g, colX[c], colY[c], from, from + nfit, f.noHeader);
              colLast[c] = f;
              // remainder continues in the same column next page, no repeated header
              queue[0] = { g: f.g, from: from + nfit, col: c, nextPageOnly: true, noHeader: true };
              continue;
            }
          }
        }
        // 3) front can't go here yet — backfill the gap with a later group
        var placed = -1;
        for (var qi = 1; qi < queue.length; qi++) {
          var it = queue[qi];
          if (fits(it, c)) {
            place(it, c, IMG_MAX);
            placed = qi;
            break;
          }
          if (fits(it, 1 - c)) {
            place(it, 1 - c, IMG_MAX);
            placed = qi;
            break;
          }
        }
        if (placed >= 0) {
          queue.splice(placed, 1);
          continue;
        }
        // 3b) no whole group fits — split the next group into the leftover gap
        var rc = colY[0] <= colY[1] ? 0 : 1;
        var rcRoom = H - BOTTOM - colY[rc];
        if (rcRoom >= 26) {
          for (var qj = 1; qj < queue.length; qj++) {
            var git = queue[qj];
            if (!git.g || git.nextPageOnly) continue;
            var gf = git.from || 0,
              gg = gapBefore(colLast[rc], git);
            var gnfit = rowsThatFit(git.g, gf, rcRoom - gg, git.noHeader);
            if (gnfit >= 2 && git.g.items.length - gf - gnfit >= 1) {
              colY[rc] += gg;
              colY[rc] = drawGroup(git.g, colX[rc], colY[rc], gf, gf + gnfit, git.noHeader);
              colLast[rc] = git;
              queue[qj] = { g: git.g, from: gf + gnfit, col: rc, nextPageOnly: true, noHeader: true };
              placed = qj;
              break;
            }
          }
          if (placed >= 0) continue;
        }
        // 4) nothing fits — overflow an over-tall front on a fresh page, else break
        if (isFresh()) {
          f.nextPageOnly = false;
          place(queue.shift(), 0, IMG_MAX);
        } else {
          newPage();
        }
      }
      y = Math.max(colY[0], colY[1]) + vgap(4);
      atTop = false;
    }

    if (data.colourways && data.colourways.length) {
      var cwCols = 3,
        cwGap = 4,
        cwW = (CW - cwGap * (cwCols - 1)) / cwCols;
      var swPadV = compact ? 1.1 : 1.9,
        swNameLH = mm(7.2) * 1.15,
        swRowNominal = 6 + 2 * (compact ? 1.1 : 1.9);
      var SW_IMG = data.swatchImages || {};
      function swatchImg(sw) {
        return sw && sw.img ? SW_IMG[normSwatchUrl(sw.img)] || null : null;
      }
      // dot colour: explicit hex, else the PDP's CSS-keyword fallback (memoised)
      function swatchRGB(sw) {
        if (!sw) return null;
        if (sw._rgb !== undefined) return sw._rgb;
        var rgb = sw.hex ? hexRGB(sw.hex) : null;
        if (!rgb) rgb = cssColorToHex(sw.name);
        sw._rgb = rgb;
        return rgb;
      }
      function swCellBlockH(sw) {
        font("semibold", 7.2);
        if (swatchImg(sw) || swatchRGB(sw)) {
          var n = doc.splitTextToSize(safe(sw.name), cwW - 8).length;
          return n * swNameLH;
        }
        var np = doc.splitTextToSize(safe(sw.name), cwW - 8).length;
        return np * swNameLH + 3.4;
      }
      function swatchGrid(swatches) {
        y -= swPadV;
        for (var r = 0; r < swatches.length; r += cwCols) {
          var rowSw = swatches.slice(r, r + cwCols);
          var maxBlock = 0,
            anyDot = false;
          for (var m = 0; m < rowSw.length; m++) {
            maxBlock = Math.max(maxBlock, swCellBlockH(rowSw[m]));
            if (swatchImg(rowSw[m]) || swatchRGB(rowSw[m])) anyDot = true;
          }
          var rh = Math.max(anyDot ? 6 : 0, maxBlock) + 2 * swPadV;
          ensure(rh);
          var midY = y + rh / 2;
          for (var c = 0; c < rowSw.length; c++) {
            var sw = rowSw[c];
            var cx = M + c * (cwW + cwGap);
            var isSel = !!(data.selectedNames && data.selectedNames[sw.name]);
            font("semibold", 7.2);
            var sImg = swatchImg(sw);
            if (sImg) {
              // real swatch image, clipped into the colour dot (image > hex > text)
              doc.saveGraphicsState();
              doc.circle(cx + 3, midY, 3, null);
              doc.clip();
              doc.discardPath();
              doc.addImage(sImg.url, "JPEG", cx, midY - 3, 6, 6, undefined, "FAST");
              doc.restoreGraphicsState();
              stroke(REED_LINE);
              doc.setLineWidth(0.3);
              doc.circle(cx + 3, midY, 3, "S");
              if (isSel) {
                stroke(REED_DEEP);
                doc.setLineWidth(0.5);
                doc.circle(cx + 3, midY, 3.9, "S");
              }
              var nmi = doc.splitTextToSize(safe(sw.name), cwW - 8);
              var bTopi = midY - (nmi.length * swNameLH) / 2;
              ink(INK);
              for (var ai = 0; ai < nmi.length; ai++)
                doc.text(nmi[ai], cx + 8, bTopi + ai * swNameLH, {
                  baseline: "top",
                });
            } else if (swatchRGB(sw)) {
              var rgb = swatchRGB(sw) || [200, 200, 200];
              var brd = [
                Math.round(rgb[0] * 0.72),
                Math.round(rgb[1] * 0.72),
                Math.round(rgb[2] * 0.72),
              ];
              fill(rgb);
              stroke(brd);
              doc.setLineWidth(0.3);
              doc.circle(cx + 3, midY, 3, "FD");
              if (isSel) {
                stroke(REED_DEEP);
                doc.setLineWidth(0.5);
                doc.circle(cx + 3, midY, 3.9, "S");
              }
              var nm = doc.splitTextToSize(safe(sw.name), cwW - 8);
              var blockH = nm.length * swNameLH;
              var bTop = midY - blockH / 2;
              ink(INK);
              for (var a = 0; a < nm.length; a++)
                doc.text(nm[a], cx + 8, bTop + a * swNameLH, {
                  baseline: "top",
                });
            } else {
              var pnm = doc.splitTextToSize(safe(sw.name), cwW - 8);
              var pw = 0;
              for (var k = 0; k < pnm.length; k++)
                pw = Math.max(pw, doc.getTextWidth(pnm[k]));
              // no colour connected -> name-only pill, like the PDP
              var pillW = Math.min(cwW, pw + 7.4);
              var pillH = pnm.length * swNameLH + 3.4;
              var pillTop = midY - pillH / 2;
              fill(BONE);
              stroke(isSel ? REED_DEEP : LINE);
              doc.setLineWidth(isSel ? 0.6 : 0.3);
              doc.roundedRect(
                cx,
                pillTop,
                pillW,
                pillH,
                pillH / 2,
                pillH / 2,
                "FD",
              );
              ink(INK);
              var tTop = midY - (pnm.length * swNameLH) / 2 + swNameLH / 2;
              for (var b = 0; b < pnm.length; b++)
                doc.text(pnm[b], cx + pillW / 2, tTop + b * swNameLH, {
                  align: "center",
                  baseline: "middle",
                });
            }
          }
          y += rh;
        }
      }
      data.colourways.forEach(function (section) {
        var groups = (section.groups || []).filter(function (g) {
          return g.swatches && g.swatches.length;
        });
        if (!groups.length) return;
        eyebrow(section.label || data.labels.colourways, 3 + swRowNominal);
        groups.forEach(function (g) {
          if (g.sub) {
            ensure(mm(6) + 1.6 + swRowNominal);
            font("bold", 6.4);
            ink(REED_DEEP);
            doc.text(safe(g.sub), M, y, { baseline: "top", charSpace: 0.2 });
            y += mm(6.4) + 1.8;
          }
          swatchGrid(g.swatches);
          y += vgap(2);
        });
        y += vgap(1);
      });
    }

    if (data.included && data.included.length) {
      eyebrow(data.labels.included, Math.ceil(data.included.length / 2) * 5.4);
      var icCols = 2,
        icGap = 6,
        icW = (CW - icGap) / icCols;
      var icLH = mm(7.4) * 1.35;
      for (var ii = 0; ii < data.included.length; ii += icCols) {
        // row height follows the tallest item in the pair (translations wrap)
        var rowLines = 1;
        for (var cc = 0; cc < icCols; cc++) {
          var itm = data.included[ii + cc];
          if (!itm) continue;
          font("normal", 7.4);
          rowLines = Math.max(rowLines, doc.splitTextToSize(safe(itm), icW - 4).length);
        }
        var icRowH = 5.4 + (rowLines - 1) * icLH;
        ensure(icRowH);
        for (var cc = 0; cc < icCols; cc++) {
          var it = data.included[ii + cc];
          if (!it) continue;
          var x = M + cc * (icW + icGap);
          var icC = y + 1.2;
          stroke(REED);
          doc.setLineWidth(0.3);
          doc.line(x, icC + 0.1, x + 0.7, icC + 0.6);
          doc.line(x + 0.7, icC + 0.6, x + 1.85, icC - 0.6);
          font("normal", 7.4);
          ink(INK_SOFT);
          var wl = doc.splitTextToSize(safe(it), icW - 4);
          for (var q = 0; q < wl.length; q++)
            doc.text(wl[q], x + 3.6, icC + q * icLH, {
              baseline: "middle",
            });
        }
        y += icRowH;
      }
      y += vgap(3);
    }

    if (data.ordering && data.ordering.length) {
      eyebrow(data.labels.ordering, 17);
      statBand(data.ordering, true);
    }

    var wastedTail = false;
    if (data.cta && data.cta.heading) {
      var ctaH = 22;
      var ctaDivH = atTop ? 0 : vgap(4);
      if (y + ctaDivH + ctaH > H - BOTTOM) {
        wastedTail = doc.getNumberOfPages() === 1;
        doc.addPage();
        y = M + headPad;
        contHeader();
      }
      if (!atTop) {
        rule(y);
        y += vgap(4);
      }
      atTop = false;
      fill(REED);
      doc.roundedRect(M, y, CW, ctaH, mm(10), mm(10), "F");
      font("extrabold", 11);
      ink(WHITE);
      doc.setLineHeightFactor(1.05);
      var hl = doc.splitTextToSize(safe(data.cta.heading), CW * 0.56);
      for (var k = 0; k < hl.length; k++)
        doc.text(hl[k], M + 6, y + 5 + k * mm(11) * 1.05, { baseline: "top" });
      doc.setLineHeightFactor(1.15);
      var rx = W - M - 6;
      font("bold", 7.6);
      ink(WHITE);
      doc.text(safe(data.cta.site), rx, y + 6, {
        align: "right",
        baseline: "top",
      });
      font("normal", 6.4);
      doc.setTextColor(230, 232, 224);
      doc.text(safe(data.cta.phone), rx, y + 6 + mm(7.6) + 0.6, {
        align: "right",
        baseline: "top",
      });
      if (data.cta.showroom)
        doc.text(
          safe(data.cta.showroom),
          rx,
          y + 6 + mm(7.6) + 0.6 + mm(6.4) + 0.6,
          { align: "right", baseline: "top" },
        );
      y += ctaH + 3;
    }

    return { doc: doc, wastedTail: wastedTail };
  }

  // build once; rebuild compact only if the CTA alone spilled to a new page
  function render(data, hero) {
    var r = buildPdf(data, hero);
    if (r.wastedTail) {
      var c = buildPdf(data, hero, { compact: true });
      if (c.doc.getNumberOfPages() < r.doc.getNumberOfPages()) return c.doc;
    }
    return r.doc;
  }

  function filenameFor(data) {
    var base = (data.title || data.handle || "product").toString();
    if (base.normalize) base = base.normalize("NFD").replace(/[̀-ͯ]/g, "");
    base = base
      .replace(/&/g, " and ")
      .replace(/[^A-Za-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/^[Qq]uell-/, "");
    if (!base) base = "product";
    return "Quell-" + base + "-Spec-Sheet.pdf";
  }

  function previewLoadingHTML(label, title) {
    var esc = function (s) {
      return String(s || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;");
    };
    return (
      '<!doctype html><meta charset="utf-8">' +
      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
      "<title>" +
      esc(title || "Quell — Spec sheet") +
      "</title>" +
      "<style>html,body{height:100%;margin:0}" +
      "body{display:flex;flex-direction:column;align-items:center;justify-content:center;" +
      "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;" +
      "color:#5e6b52;background:#f7f6f1}" +
      ".s{width:34px;height:34px;border:3px solid #dbe0d1;border-top-color:#5e6b52;" +
      "border-radius:50%;animation:r .8s linear infinite}" +
      "@keyframes r{to{transform:rotate(360deg)}}" +
      ".t{margin-top:16px;font-size:14px;letter-spacing:.02em}</style>" +
      '<div class="s"></div><div class="t">' +
      esc(label) +
      "</div>"
    );
  }

  /* Core generation pipeline — load libs + images, render the PDF, deliver it.
     Shared between the PDP button (which opens a preview tab synchronously to
     dodge popup blockers) and the dealer library's "Brochure" tile (which
     downloads without a tab, because the dealer never left the library page).

     `scope` is only used by `patchLive`, which reads live prices/stock off the
     PDP DOM. On the dealer library page there is no PDP scope, so `scope` is
     null and `patchLive` no-ops on the missing selectors — the fetched payload
     already carries the price and stock the PDP rendered. */
  function findVariantIdBySku(variants, wantSku) {
    var target = String(wantSku);
    for (var vid in variants) {
      if (
        Object.prototype.hasOwnProperty.call(variants, vid) &&
        variants[vid] &&
        variants[vid].sku === target
      ) {
        return vid;
      }
    }
    return null;
  }

  /* Match a dealer-side label (e.g. "Coral") against the PDP payload's per-
     variant `opts` array. Case-insensitive. Tries exact match on any option
     value first, then the Shopify variant-title convention (opts joined with
     " / ") so multi-option products with a compound label ("Coral / 1200mm")
     still resolve. Fails silently — patchLive then falls back to the default
     variant, and the dealer sees the default PDF rather than an error. */
  function findVariantIdByLabel(variants, wantLabel) {
    var target = String(wantLabel).trim().toLowerCase();
    if (!target) return null;
    for (var vid in variants) {
      if (!Object.prototype.hasOwnProperty.call(variants, vid)) continue;
      var v = variants[vid];
      if (!v || !Array.isArray(v.opts)) continue;
      var opts = v.opts.map(function (o) { return String(o == null ? "" : o).trim().toLowerCase(); });
      if (opts.indexOf(target) !== -1) return vid;
      if (opts.join(" / ") === target) return vid;
    }
    return null;
  }

  function generate(data, options) {
    options = options || {};
    var preview = options.preview || null;
    // Three ways a caller can name a variant, tried in order until one hits:
    //   - options.variantId    — Shopify variant id (numeric), direct key
    //   - options.variantSku   — SKU string, walked against data.variants[].sku
    //   - options.variantLabel — human label (e.g. "Coral", "Carrara Marble"),
    //                            walked against data.variants[].opts. Needed
    //                            because Product Source variants carry
    //                            sku=null on ~80% of multi-variant products,
    //                            so the dealer library falls back to labels.
    // PDP uses scope only, which drops into patchLive as before.
    var variantId = options.variantId || null;
    if (!variantId && options.variantSku && data.variants) {
      variantId = findVariantIdBySku(data.variants, options.variantSku);
    }
    if (!variantId && options.variantLabel && data.variants) {
      variantId = findVariantIdByLabel(data.variants, options.variantLabel);
    }
    patchLive(data, { scope: options.scope || null, variantId: variantId });
    localiseUnits(data);
    return Promise.all([
      ensureLibs(),
      loadHero(data.hero),
      loadSwatchImages(data),
      loadHero(data.dimImage),
      loadHero(data.interiorImage),
    ]).then(function (res) {
      var img = res[1];
      data.swatchImages = res[2];
      // card gradient: reed-mist (top) → near-white (bottom). Everything sits on this.
      var tintRgb = [237, 239, 231],
        topCss = rgbCss(tintRgb),
        botCss = rgbCss(lighten(tintRgb, 0.78));
      data.cardBg = tintRgb;
      data.gradUrl = gradImg(topCss, botCss);
      data.dimImg = trimmedDataUrl(res[3]); // transparent — card gradient shows through
      data.interiorImg = heroDataUrl(res[4], "#ffffff", false);
      // normalise the photo's studio bg to white, then multiply onto the gradient
      var doc = render(data, heroDataUrl(img, [topCss, botCss], true, sampleBg(img)));
      if (preview && !preview.closed) {
        preview.location.href = String(doc.output("bloburl"));
      } else {
        doc.save(options.filename || filenameFor(data));
      }
      return doc;
    });
  }

  function bindTrigger(scope) {
    var btn = scope.querySelector("[data-spec-sheet]");
    var payloadEl = scope.querySelector("[data-spec-sheet-data]");
    if (!btn || !payloadEl) return;
    ["pointerenter", "focusin", "touchstart"].forEach(function (ev) {
      btn.addEventListener(
        ev,
        function () {
          ensureLibs().catch(function () {});
        },
        { passive: true },
      );
    });
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (btn.getAttribute("data-busy") === "1") return;
      var data;
      try {
        data = JSON.parse(payloadEl.textContent);
      } catch (err) {
        console.error("[spec-sheet] bad payload", err);
        return;
      }
      var busyLabel = btn.getAttribute("data-label-busy") || "Generating…";
      // open the tab synchronously in the click gesture — a post-await window.open is popup-blocked
      var preview = window.open("", "_blank");
      if (preview && preview.document) {
        preview.document.write(
          previewLoadingHTML(busyLabel, data.doc && data.doc.label),
        );
        preview.document.close();
      }
      var original = btn.textContent;
      btn.setAttribute("data-busy", "1");
      btn.setAttribute("aria-busy", "true");
      btn.textContent = busyLabel;
      var restore = function () {
        btn.removeAttribute("data-busy");
        btn.removeAttribute("aria-busy");
        btn.textContent = original;
      };
      generate(data, { preview: preview, scope: scope })
        .then(restore)
        .catch(function (err) {
          console.error("[spec-sheet] generation failed", err);
          if (preview && !preview.closed) {
            try {
              preview.close();
            } catch (e2) {}
          }
          var msg = btn.getAttribute("data-label-error");
          if (msg) {
            btn.textContent = msg;
            setTimeout(restore, 2500);
          } else {
            restore();
          }
        });
    });
  }

  /* Fetch a PDP's HTML, extract its `[data-spec-sheet-data]` block, run it
     through the generator. Used by the dealer library's "Brochure" tile —
     one click, one download, no PDP round-trip visible to the dealer.

     `handleOrUrl` accepts a bare handle ("emi-stackable") or a full storefront
     URL — the dealer library payload gives us the latter as the asset's `url`
     (it's the same string the storefront's PDP link uses), so this handler
     doesn't have to know which shape it received.

     `options` (optional): { variantSku, variantId, filename }. The dealer
     library's variant chip picker passes `variantSku`; anything else falls
     back to the product's default variant. */
  function generateForHandle(handleOrUrl, options) {
    var url = normalisePdpUrl(handleOrUrl);
    if (!url) return Promise.reject(new Error("spec-sheet: no product URL"));
    var opts = options || {};
    return fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("spec-sheet: fetch failed (" + res.status + ")");
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var payloadEl = doc.querySelector("[data-spec-sheet-data]");
        if (!payloadEl) throw new Error("spec-sheet: no payload on " + url);
        var data;
        try {
          data = JSON.parse(payloadEl.textContent || "");
        } catch (err) {
          throw new Error("spec-sheet: bad payload on " + url);
        }
        return generate(data, {
          variantSku: opts.variantSku || null,
          variantId: opts.variantId || null,
          variantLabel: opts.variantLabel || null,
          filename: opts.filename || null,
        });
      });
  }

  /* Shopify's locale root: "/" on the default market, "/no/" or "/de-de/" on
     localised ones. Fall back to parsing location.pathname when the storefront
     didn't inject Shopify.routes.root (older themes). The dealer library
     backend only knows the canonical EN handle, so without this prefix the
     fetch below hits the EN PDP even when the dealer is browsing in German. */
  function currentLocaleRoot() {
    try {
      if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === "string") {
        return Shopify.routes.root;
      }
    } catch (e) {}
    var m = /^\/([a-z]{2}(?:-[a-z]{2,3})?)(?:\/|$)/i.exec(window.location.pathname);
    return m ? "/" + m[1].toLowerCase() + "/" : "/";
  }

  function hasLocalePrefix(path) {
    return /^\/[a-z]{2}(?:-[a-z]{2,3})?\//i.test(path);
  }

  function normalisePdpUrl(handleOrUrl) {
    if (!handleOrUrl || typeof handleOrUrl !== "string") return null;
    var s = handleOrUrl.trim();
    if (!s) return null;
    var root = currentLocaleRoot();
    // Absolute URL — the dealer library's asset-library backend returns the
    // full storefront URL ("https://host/products/<handle>"), which is still
    // same-origin, so we need to inject the current locale prefix into its
    // path. Different-origin URLs are passed through unchanged.
    if (/^https?:\/\//i.test(s)) {
      try {
        var u = new URL(s);
        if (u.origin !== window.location.origin) return s;
        if (hasLocalePrefix(u.pathname)) return s;
        if (root === "/") return s;
        u.pathname = root.replace(/\/$/, "") + u.pathname;
        return u.toString();
      } catch (e) {
        return s;
      }
    }
    // Same-origin path: pass through if it already carries ANY locale prefix.
    // Otherwise prepend the current locale so a dealer on /de-de/pages/… gets
    // the German PDP (Shopify resolves /de-de/products/<en-handle> to the
    // translated handle via a 301 the fetch follows transparently).
    if (s.charAt(0) === "/") {
      if (hasLocalePrefix(s)) return s;
      return root === "/" ? s : root.replace(/\/$/, "") + s;
    }
    // Bare handle — mount under /{locale}/products/.
    var handle = s.replace(/^\/+/, "");
    return (root === "/" ? "/products/" : root + "products/") + handle;
  }

  // Expose the two entrypoints on window so `assets/section-dealer-cad-library.js`
  // can call them without importing anything. Kept minimal on purpose: the
  // dealer library only needs the handle-driven path; `generate` is here for
  // tests and any future page that already holds a parsed payload.
  window.QuellSpecSheet = window.QuellSpecSheet || {};
  window.QuellSpecSheet.generate = generate;
  window.QuellSpecSheet.generateForHandle = generateForHandle;

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }
  ready(function () {
    document.querySelectorAll("[data-product-main]").forEach(function (el) {
      bindTrigger(el.closest(".shopify-section") || el);
    });
  });
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector && e.target.querySelector("[data-spec-sheet]"))
      bindTrigger(e.target);
  });
})();
